<template>
  <div class="container fluid">
    <div class="mb-2">
      <date-filter
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="onDateChanged"
      ></date-filter>
    </div>

    <div class="mt-5">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm5 class="pr-4">
          <OverviewFilter @onFilter="onFilter"></OverviewFilter>
        </v-flex>
        <v-flex xs12 sm7 class="pl-4">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="series">
            <apexchart
              :key="chartKey"
              type="bar"
              height="350"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </template>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import OverviewFilter from './OverviewFilter.vue'

export default {
  components: {
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    OverviewFilter
  },
  data() {
    return {
      chartKey: 1,
      loading: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      filter: {
        product: '',
        model: '',
        headtype: '',
        color: '',
        size: '',
        status: ''
      },
      series: [
        {
          name: '',
          data: []
        }
      ],
      chartOptions: {
        colors: ['#F7856A', '#C4C4C4'],
        chart: {
          height: 500,
          type: 'bar'
        },
        plotOptions: {
          bar: {
            columnWidth: '30%',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: ['คนที่ซื้อ', 'คนที่สอบถามและเป็นสมาชิก', 'คนที่สอบถามแต่ไม่เป็นสมาชิก']
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return val.toFixed(0)
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' counts'
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getOverviewAndReport()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        // var data = await this.getPdpaReportExport();

        resolve(
          data.map((el) => {
            var pdpaStatus
            if (el.pdpa) {
              pdpaStatus = 'ยอมรับ'
            } else {
              pdpaStatus = 'ไม่ยอมรับ'
            }

            return {
              ชื่อลูกค้า: el.name,
              เพศ: el.gender,
              อายุ: el.ages,
              วันเดือนปีเกิด: el.dob ? moment(el.dob).format('DD/MM/YYYY') : '',
              เบอร์โทรศัพท์: el.phone_number,
              อีเมล: el.email,
              วันที่สมัครสมาชิก: el.register_timestamp
                ? moment(el.register_timestamp).format('DD/MM/YYYY')
                : '',
              วันหมดอายุสมาชิก: el.expired_timestamp
                ? moment(el.expired_timestamp).format('DD/MM/YYYY')
                : '',
              วันที่ต่ออายุสมาชิก: el.renew_timestamp
                ? moment(el.renew_timestamp).format('DD/MM/YYYY')
                : '',
              การยินยอม_PDPA: pdpaStatus
            }
          })
        )
      })
    },
    getOverviewAndReport() {
      return new Promise((resolve) => {
        const vm = this
        const data = {
          pageid: vm.selectedBot.pageid, // required
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }

        if (vm.filter.product) {
          Object.assign(data, { product: vm.filter.product })
        }
        if (vm.filter.model) {
          Object.assign(data, { model: vm.filter.model })
        }
        if (vm.filter.headtype) {
          Object.assign(data, { headtype: vm.filter.headtype })
        }
        if (vm.filter.color) {
          Object.assign(data, { colour: vm.filter.color })
        }
        if (vm.filter.size) {
          Object.assign(data, { size: vm.filter.size })
        }

        if (vm.series[0].data) {
          vm.series.data = []
        }

        vm.$store.dispatch('loading')
        api.getLamyOverviewAndReport(data, (err, response) => {
          vm.$store.dispatch('loading')

          if (err) {
            console.error(err)
            return
          }

          if (response && response.responsecode == 200) {
            const chartData = response.data[0]
            vm.series[0].data = Object.values(chartData)
            vm.chartKey++
            resolve(response.data)
          }
        })
      })
    },
    onFilter(payload) {
      this.filter = {
        product: payload.product,
        model: payload.model,
        headtype: payload.headType,
        color: payload.color,
        size: payload.size
      }
      this.getOverviewAndReport()
    },
    onDateChanged() {
      this.getOverviewAndReport()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/OverviewAndReport.vue